import { STRIPE_TAX_ID_TYPES } from '../../../stripe/domain/tax-id-types';
import { map } from 'lodash';
import { z } from 'zod';

const codes = map(STRIPE_TAX_ID_TYPES, 'code');

export const stripeCustomerCreateSchema = z.object({
	name: z.string().nonempty('Name is required').min(1),
	email: z.string().email('Email is invalid').nonempty('Email is required'),
	taxIdType: z
		.string()
		.optional()
		.nullable()
		.refine((val) => val === '' || !val || codes.includes(val), {
			error: 'Invalid tax ID type',
		})
		.transform((val) => {
			if (!val || val === '') {
				return null;
			}
			return val;
		}),
	taxIdValue: z.string().optional().nullable(),
	address: z.object({}).catchall(z.unknown()).optional(),
});
